import {Section, Title, CheckboxControl} from './index.styled';

interface Props {
	disabled?: boolean;
	onShowBaselineChange: (data: boolean) => void;
	onCarryForwardChange: (data: boolean) => void;
	showBaseline: boolean;
	carryForward: boolean;
}

export function SettingsControl({disabled, onShowBaselineChange, onCarryForwardChange, showBaseline, carryForward}: Props) {
	return (
		<Section>
			<Title size='small' font='mono' color='neutral64'>Settings</Title>
			<CheckboxControl checked={showBaseline} onCheckedChange={(value) => onShowBaselineChange(!!value)} label='Show Baseline' disabled={disabled}/>
			<CheckboxControl checked={carryForward} onCheckedChange={(value) => onCarryForwardChange(!!value)} label='Carry Forward' disabled={disabled}/>
		</Section>
	);
}
